import DriveAround from "./DriveAround";

const CheapestCars = ({
  locationName,
  type,
  results,
  name,
  locale,
  airportData
}: {
  locationName: string;
  type: string;
  results: Result;
  name: string;
  locale: string;
  airportData: AirportNameData;
}) => {
  return (
    <section className="w-full">
      <DriveAround
        name={name}
        type={type}
        results={results}
        locale={locale}
        locationName={locationName}
        airportData={airportData}
      />
    </section>
  );
};

export default CheapestCars;
